import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import moment from "moment";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { Link } from "react-router-dom";
import Calendar from "react-calendar";
import { mapGameToEvent } from "../components/utils/GameToEvent";

import "react-calendar/dist/Calendar.css";
import { getEvent } from "services/event_service";
import { getGames } from "services/game_service";

function App() {
  const [datesToAddContentTo, setDatesToAddContentTo] = useState([]);
  const [eventsToday, setEventsToday] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [gameList, setGameList] = useState([]);

  useEffect(() => {
    async function initComponent() {
      let eventsList = await getEvent();
      let games = await getGames();
      let datesEvent = [];

      eventsList.forEach((event) => {
        datesEvent.push({
          date: new Date(event.attributes.when),
          type: event.attributes.type,
        });
      });

      games.forEach((game) => {
        datesEvent.push({ date: new Date(game.attributes.date), type: "Jogo" });
      });

      setDatesToAddContentTo(datesEvent);
      setEventList(eventsList);
      setGameList(games);

      getTodayEvents(games, eventsList);
    }
    initComponent();
  }, []);

  function getTodayEvents(gamesList, eventsList) {
    const selectedDate = moment();

    const eventsSelectedDate = eventsList.filter((el) =>
      moment(el.attributes.when).isSame(selectedDate, "day")
    );

    let gamesSelectedDate = gamesList.filter((el) =>
      moment(el.attributes.date).isSame(selectedDate, "day")
    );

    gamesSelectedDate = mapGameToEvent(gamesSelectedDate);
    setEventsToday(eventsSelectedDate.concat(gamesSelectedDate));
  }

  function onChange(nextValue) {
    const selectedDate = moment(nextValue);

    const eventsSelectedDate = eventList.filter((el) =>
      moment(el.attributes.when).isSame(selectedDate, "day")
    );

    let gamesSelectedDate = gameList.filter((el) =>
      moment(el.attributes.date).isSame(selectedDate, "day")
    );

    gamesSelectedDate = mapGameToEvent(gamesSelectedDate);
    setEventsToday(eventsSelectedDate.concat(gamesSelectedDate));
  }

  function tileContent({ date, view }) {
    let event = {};
    if (
      datesToAddContentTo.find((el) => {
        if (moment(el.date).isSame(moment(date), "day")) {
          event = el;
          return true;
        }
        return false;
      })
    ) {
      if (view === "month") {
        switch (event.type) {
          case "Treino":
            return "trainingCSS";
          case "Jogo":
            return "gameCSS";
          default:
            return "otherCSS";
        }
      }
    }
  }

  const canEditEvent = () => {
    if (
      localStorage.getItem("role") === "Treinador" ||
      localStorage.getItem("role") === "Clube"
    ) {
      return true;
    }

    return false;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
          <TopAdd></TopAdd>
          <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li className="is-active">Calendário</li>
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Calendário da equipa</h1>
                  </div>
                </div>
              </div>
            </div>

            {canEditEvent() && (
              <Link to={`/eventos`} className="button">
                Adicionar Evento
              </Link>
            )}
            <br />
            <br />
            <br />

            <div className="hero is-footsolution">
              <div className="columns">
                <div className="column is-6 is-4-desktop">
                  <Calendar
                    className="calendar-style"
                    tileClassName={tileContent}
                    onChange={onChange}
                  />
                </div>
                <div className="column is-6">
                  <div>
                  <div style={{"display": "flex"}} ><div style={{width: "30px", height: "20px", backgroundColor: "#1F395E", marginRight: "10px", marginBottom: "10px"}}></div>{"  "}<h2 className="bold">JOGO</h2></div> 
                  <div style={{"display": "flex"}} ><div style={{width: "30px", height: "20px", backgroundColor: "#F39237", marginRight: "10px", marginBottom: "10px"}}></div>{"  "}<h2 className="bold">TREINO</h2></div> 
                  <div style={{"display": "flex"}} ><div style={{width: "30px", height: "20px", backgroundColor: "#AFDEDC", marginRight: "10px", marginBottom: "10px"}}></div>{"  "}<h2 className="bold">OUTROS</h2></div> 
                  </div>
                </div>
              </div>
            </div>

            <br />
            <table className="table is-fullwidth">
              <thead>
                <tr>
                  <th style={{ width: "30%" }}>
                    <abbr title="Position">Evento</abbr>
                  </th>
                  <th style={{ width: "30%" }}>
                    <abbr title="Won">Data</abbr>
                  </th>
                  <th style={{ width: "30%" }}>
                    <abbr title="Won">Onde</abbr>
                  </th>
                  <th style={{ width: "30%" }}>
                    <abbr title="Drawn">Ações</abbr>
                  </th>
                </tr>
              </thead>
              <tbody>
                {eventsToday.map((el, idx) => (
                  <tr key={idx}>
                    <td>{el.attributes.type}</td>
                    <td>
                      {el.attributes.when
                        ? moment(el.attributes.when).format(
                            "DD-MM-YYYY - HH:mm"
                          )
                        : ""}
                    </td>
                    <td>{el.attributes.where}</td>
                    <td>
                      {" "}
                      <Popup
                        trigger={<i className="fa fa-ellipsis-v"></i>}
                        position="left center"
                      >
                        <div className="dropdown-content">
                          <Link
                            className="dropdown-item"
                            to={
                              el.attributes.type.startsWith("vs")
                                ? `/jogos/${el.id}`
                                : `/eventos/${el.id}`
                            }
                          >
                            Detalhe
                          </Link>
                          {canEditEvent() && (
                            <Link
                              className="dropdown-item"
                              to={
                                el.attributes.type.startsWith("vs")
                                  ? `/jogos/${el.id}/apagar`
                                  : `/eventos/${el.id}/apagar`
                              }
                            >
                              Remover Evento
                            </Link>
                          )}
                        </div>
                      </Popup>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
          <RightAdd></RightAdd>
         </div>

        </div>
      </div>
    </div>
  );
}

export default App;
